import { render, staticRenderFns } from "./Template.vue?vue&type=template&id=f14f7d32&scoped=true&"
import script from "./Mecanica.vue?vue&type=script&lang=js&"
export * from "./Mecanica.vue?vue&type=script&lang=js&"
import style0 from "./Mecanica.scss?vue&type=style&index=0&id=f14f7d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f14f7d32",
  null
  
)

export default component.exports